import React, { useEffect } from 'react';
import { Column } from 'components/Layout/Grid';
import Text from 'components/Text';
import TextArea from 'components/TextArea';
import { useEnvironment } from 'hooks/useEnvironment';
import { EnvironmentTypes } from '../Description/interface';
import { ITechnicalDescription } from './interface';
import { EnumCategories } from 'models/Ticket';

const TechnicalDescription: React.FC<ITechnicalDescription> = (props) => {
  const {
    protocolCategory,
    technicalDescription,
    setTechnicalDescription,
    isEditing
  } = props;
  const development = useEnvironment();

  useEffect(() => {
    if (!isEditing) {
      setTechnicalDescription('');
    }
  }, [protocolCategory]);

  useEffect(() => {
    const environment = process.env.REACT_APP_HOME_URL;

    if (!isEditing && (development || environment === EnvironmentTypes.dev || environment === EnvironmentTypes.qas)) {
      setTechnicalDescription('Protocolo aberto pela equipe de desenvolvimento CCare - AP');
    }
  }, []);

  const description: string = protocolCategory === EnumCategories.RECLAMACAO_TECNICA ?
    'Descrição Detalhada da Queixa Técnica' : 'Descrição';

  return (
    <Column className="mt-5 relative">
      <Text className="mb-2 color-blue-gray" size={12}>
        {description}
      </Text>
      <TextArea
        stateName="description"
        id="technicalDescription"
        onChange={(e) => setTechnicalDescription(e.target.value)}
        value={technicalDescription}
        minLength={10}
        name="Descrição da queixa"
        required
        placeholder="descrição"
        style={{
          flex: 1,
          height: 200,
          minHeight: 200,
        }}
      />
    </Column>
  );
};

export default TechnicalDescription;
